import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import scopeIcon from "../../../../images/scope.png";
import exclusionIcon from "../../../../images/exclusion.png";
import warrantyIcon from "../../../../images/warranty.png";
import deliveryIcon from "../../../../images/delivery.png";

const QuotationProfessionalTemplate = ({
  quotation = {},
  enquiry = {},
  quotationData = [],
  selectedValue,
  bankAc,
  dgSignBase64,
  dgSignAspectRatio,
  headerBase64,
  footerBase64,
  footerAspectRatio,
  numberToWords,
  paymentTermOptions = [],
  selectedPaymentTerm = "",
  orgDetails = {},
  type = "QUOTATION",
}) => {

  console.log("TEMPLATE RECEIVED orgDetails:", orgDetails);

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  const margin = 8;
  const blue = [18, 54, 88];
  const lightBlue = [240, 246, 252];
  const border = [215, 215, 215];
  const gray = [90, 90, 90];

  const money = (v) =>
    Number(v || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (v) =>
    v
      ? new Date(v).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      : "-";
  //page height 
  const pageHeight = doc.internal.pageSize.getHeight();
  const bottomLimit = pageHeight - 12;

  const addPageIfNeeded = (neededHeight = 20) => {
    if (y + neededHeight > bottomLimit) {
      doc.addPage();
      doc.setDrawColor(...border);
      doc.rect(margin, 6, pageWidth - margin * 2, 285);
      y = 10;
    }
  };

  const stripHtml = (html = "") =>
    String(html)
      .replace(/<li[^>]*>/gi, "\n• ")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  const drawLabelValue = (label, value, x, y, labelW = 25) => {
    doc.setFontSize(6.2);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...gray);
    doc.text(label, x, y);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(20, 20, 20);
    doc.text(":", x + labelW, y);
    doc.text(String(value || "-"), x + labelW + 3, y);
  };

  const drawTitle = (title, x, y, w) => {
    doc.setFillColor(...lightBlue);
    doc.setDrawColor(...border);
    doc.rect(x, y, w, 7, "FD");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(...blue);
    doc.text(title, x + 3, y + 5);
  };

  const drawSmallBox = (title, content, x, y, w, h) => {
    doc.setDrawColor(...border);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, y, w, h, 1.5, 1.5, "FD");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(...blue);
    doc.text(title, x + 3, y + 6);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.7);
    doc.setTextColor(35, 35, 35);

    let yy = y + 8;
    const lines = Array.isArray(content) ? content : [content];

    lines.forEach((line) => {
      const wrapped = doc.splitTextToSize(String(line || "-"), w - 6);
      wrapped.forEach((part) => {
        if (yy < y + h - 1) {
          doc.text(part, x + 3, yy);
          yy += 3;
        }
      });
    });
  };

  const getBoxHeight = (content, width) => {
    const lines = Array.isArray(content) ? content : [content];

    let totalLines = 0;

    lines.forEach((line) => {
      const wrapped = doc.splitTextToSize(String(line || "-"), width - 6);
      totalLines += wrapped.length;
    });

    return Math.max(16, 10 + totalLines * 3.2 + 3);
  };

  // outer border
  doc.setDrawColor(...border);
  doc.rect(margin, 6, pageWidth - margin * 2, 285);

  // HEADER
  const headerY = 5;
  const leftW = 72;
  const headerH = 35;
  const midW = 60;
  const rightW = pageWidth - margin * 2 - leftW - midW;

  doc.setDrawColor(...border);
  doc.setDrawColor(220, 220, 220);

  const separatorTop = headerY + 3;
  const separatorBottom = headerY + headerH - 3;

  const headerContentBottom = headerY + 28;

  doc.line(
    margin + leftW,
    headerY + 3,
    margin + leftW,
    headerContentBottom
  );

  doc.line(
    margin + leftW + midW,
    headerY + 3,
    margin + leftW + midW,
    headerContentBottom
  );
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.4);

  doc.line(
    margin + 4,
    headerY + 30,
    pageWidth - margin - 4,
    headerY + 30
  );

  //company logo 

  if (headerBase64) {
    doc.addImage(headerBase64, "PNG", margin + 5, headerY + 3, 12, 12);
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);

  const x = margin + 24;
  const yPos = headerY + 8;

  // Company name is split into two differently-colored chunks if it contains
  // a space (e.g. "Shreesh" + "Tech"); otherwise rendered as a single string.
  const fullCompanyName = orgDetails?.name || "";
  const splitIdx = Math.ceil(fullCompanyName.length / 2);
  const namePart1 = orgDetails?.name ? fullCompanyName : fullCompanyName.slice(0, splitIdx);
  const namePart2 = orgDetails?.name ? "" : fullCompanyName.slice(splitIdx);

  doc.setTextColor(20, 20, 20);
  doc.text(namePart1, x, yPos);

  if (namePart2) {
    doc.setTextColor(11, 93, 148);
    doc.text(namePart2, x + doc.getTextWidth(namePart1), yPos);
  }

  doc.setTextColor(20, 20, 20);
  doc.setFontSize(10);
  doc.text(orgDetails?.company_subtitle || "", margin + 24, headerY + 12);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);
  doc.text(
    orgDetails?.tagline || "",
    margin + 5,
    headerY + 20
  );
  doc.text(
    orgDetails?.tagline_2 || "",
    margin + 5,
    headerY + 24
  );

  //end of company block
  //middle block

  const midX = margin + leftW + 5;
  doc.setFontSize(6.8);
  doc.setTextColor(...gray);

  const contactY = headerY + 6;

  [
    orgDetails?.phone || "",
    orgDetails?.mail || "",
    orgDetails?.website || "",
    orgDetails?.address_1 || "",
    orgDetails?.address_2 || "",
  ].forEach((t, i) => doc.text(t, midX, contactY + i * 5));

  const rightX = margin + leftW + midW + 6;
  //end of middle block

  //quotation block 
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(11, 93, 148);
  doc.text(type, rightX, headerY + 8);

  doc.setFontSize(8);
  doc.setTextColor(20, 20, 20);
  doc.text(quotation?.qu_no || "-", rightX, headerY + 12);

  drawLabelValue(
    "Date",
    formatDate(quotation?.date),
    rightX,
    headerY + 15,
    20
  );

  drawLabelValue(
    "Valid Until",
    formatDate(quotation?.valid_date),
    rightX,
    headerY + 19,
    20
  );

  drawLabelValue(
    "Revision",
    `R${quotation?.revision_no || 1}`,
    rightX,
    headerY + 23,
    20
  );

  drawLabelValue(
    "Status",
    quotation?.quotation_status || "-",
    rightX,
    headerY + 27,
    20
  );

  let y = headerY + headerH;


  // TOP THREE CARDS
  const gap = 6;
  const cardW = (pageWidth - margin * 2 - gap * 2) / 3;


  const billX = margin;
  const quoteX = billX + cardW + gap;
  const otherX = quoteX + cardW + gap;

  // Only vertical separators, no card box
  doc.setDrawColor(220, 220, 220);


  // Headings only
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...blue);

  const headingY = y;
  const contentY = y + 4;

  doc.text("BILL TO", billX + 6, headingY);
  doc.text("QUOTATION FOR", quoteX + 6, headingY);
  doc.text("OTHER DETAILS", otherX + 6, headingY);

  // bill to
  let by = contentY;

  const companyName =
    quotation?.customer_company ||
    enquiry?.company_name ||
    enquiry?.customer_company ||
    "-";

  const customerName =
    quotation?.customer_name ||
    enquiry?.customer_name ||
    enquiry?.name ||
    enquiry?.contact_name ||
    "-";

  const mobileNo =
    quotation?.customer_mobile ||
    enquiry?.customer_mobile ||
    enquiry?.mobile_no ||
    enquiry?.contact_phone ||
    enquiry?.contact_whatsapp ||
    "-";

  const email =
    quotation?.customer_email ||
    enquiry?.customer_email ||
    enquiry?.email ||
    enquiry?.contact_email ||
    "-";

  const gstin =
    quotation?.customer_gstin ||
    enquiry?.customer_gstin ||
    enquiry?.gstin ||
    "-";

  const address =
    quotation?.customer_address ||
    enquiry?.customer_address ||
    enquiry?.address ||
    enquiry?.location_city ||
    "-";

  doc.setFontSize(6.2);
  doc.setTextColor(20, 20, 20);

  // Company name
  doc.setFont("helvetica", "bold");
  doc.text(String(companyName), billX + 6, by);
  by += 4;

  // Customer name
  doc.setFont("helvetica", "normal");
  doc.text(String(customerName), billX + 6, by);
  by += 4;

  // Mobile
  doc.text(String(mobileNo), billX + 6, by);
  by += 4;

  // Email
  doc.text(String(email), billX + 6, by);
  by += 4;

  // GSTIN
  doc.text(`GSTIN: ${gstin}`, billX + 6, by);
  by += 4;

  // Address
  doc
    .splitTextToSize(String(address), cardW - 6)
    .slice(0, 3)
    .forEach((line) => {
      doc.text(line, billX + 6, by);
      by += 4;
    });
  const billBottom = by;

  //end of bill to 

  //quottaion for
  let qy = contentY;

  const requirementText =
    quotation?.requirement ||
    enquiry?.eq_description ||
    enquiry?.summary ||
    "-";

  stripHtml(requirementText)
    .split("\n")
    .filter(Boolean)
    .slice(0, 3)
    .forEach((line) => {
      doc.text(`• ${line.replace("•", "").trim()}`, quoteX + 6, qy);
      qy += 3;
    });

  // NO EXTRA GAP HERE
  qy += 1;

  drawLabelValue(
    "Business Type",
    quotation?.business_type || "-",
    quoteX + 6,
    qy,
    22
  );
  qy += 4;

  drawLabelValue(
    "No. Users",
    quotation?.no_of_users || "-",
    quoteX + 6,
    qy,
    22
  );
  qy += 4;

  drawLabelValue(
    "Expected Launch",
    formatDate(quotation?.expected_start_date),
    quoteX + 6,
    qy,
    22
  );
  qy += 4;

  // Remarks Heading
  doc.setFont("helvetica", "bold");
  doc.setFontSize(6.2);
  doc.setTextColor(...gray);
  doc.text("Remarks", quoteX + 6, qy);

  qy += 4;

  // Remarks Content
  const remarksText =
    quotation?.requirement_remarks ||
    quotation?.remarks ||
    "-";

  doc.setFont("helvetica", "normal");
  doc.setTextColor(20, 20, 20);

  doc
    .splitTextToSize(remarksText, cardW - 12)
    .slice(0, 2)
    .forEach((line) => {
      doc.text(line, quoteX + 6, qy);
      qy += 3.5;
    });

  const quotationBottom = qy;

  //end of quottaion fopr 

  drawLabelValue("Enquiry Ref", quotation?.eq_no, otherX + 6, contentY, 26);
  drawLabelValue("Lead Source", enquiry?.lead_source || enquiry?.eq_source, otherX + 6, contentY + 5, 26);
  drawLabelValue("Prepared By", quotation?.prepared_by || "-", otherX + 6, contentY + 10, 26);
  drawLabelValue("Assigned To", quotation?.assigned_to || "-", otherX + 6, contentY + 15, 26);
  drawLabelValue("Close Date", formatDate(quotation?.expected_close_date), otherX + 6, contentY + 20, 26);

  const otherBottom = y + 29;

  const detailsBottom = Math.max(
    billBottom,
    quotationBottom,
    otherBottom
  );

  // draw vertical lines only till content bottom
  doc.setDrawColor(220, 220, 220);

  doc.line(
    quoteX - gap / 2,
    y + 1,
    quoteX - gap / 2,
    detailsBottom - 1
  );

  doc.line(
    otherX - gap / 2,
    y + 1,   // start below black line
    otherX - gap / 2,
    detailsBottom - 1
  );
  y = detailsBottom;

  // ITEMS TABLE
  let slNo = 1;
  let lastSection = "General";
  const rows = [];

  quotationData.forEach((item) => {
    const sectionName = item.section_name || "General";

    if (sectionName !== "General" && sectionName !== lastSection) {
      rows.push([
        {
          content: sectionName,
          colSpan: 10,
          styles: {
            fontStyle: "bold",
            textColor: blue,
            fillColor: [245, 248, 252],
            halign: "left",
          },
        },
      ]);
    }

    const qty = Number(item.qty || 0);
    const rate = Number(item.unitprice || 0);
    const discount = Number(item.discount || 0);
    const tax = Number(item.tax || 0);

    const base = qty * rate;
    const discountAmount = (base * discount) / 100;
    const taxable = base - discountAmount;
    const amount = item.totalprice || taxable + taxable * (tax / 100);

    rows.push([
      slNo++,
      item.service_name || "-",
      item.description || "-",
      qty,
      item.unit || "-",
      item.duration || "-",
      ` ${money(rate)}`,
      `${discount}%`,
      `${tax}% GST`,
      ` ${money(amount)}`,
    ]);

    lastSection = sectionName;
  });

  const tableWidth = pageWidth - margin * 2 - 8;
  const tableX = margin + 4;

  addPageIfNeeded(55);
  autoTable(doc, {
    startY: y,
    margin: { left: tableX },

    tableWidth,

    head: [[
      "#",
      "Item / Service",
      "Description",
      "Qty",
      "Unit",
      "Duration",
      "Rate",
      "Discount (%)",
      "Tax",
      "Amount",
    ]],

    body: rows,

    theme: "grid",

    styles: {
      fontSize: 6,
      cellPadding: 2,
      valign: "middle",
      overflow: "linebreak",
      lineColor: border,
      lineWidth: 0.1,
    },

    headStyles: {
      fillColor: blue,
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      fontSize: 6,
    },

    columnStyles: {
      0: { cellWidth: 7, halign: "center" },
      1: { cellWidth: 30 },
      2: { cellWidth: 32 },
      3: { cellWidth: 8, halign: "center" },
      4: { cellWidth: 10, halign: "center" },
      5: { cellWidth: 14, halign: "center" },
      6: { cellWidth: 22, halign: "right" },
      7: { cellWidth: 18, halign: "center" },
      8: { cellWidth: 17, halign: "center" },
      9: { cellWidth: 24, halign: "right" },
    },
  });
  y = doc.lastAutoTable.finalY - 1;
  addPageIfNeeded(60);
  // TOTALS
  let subTotal = 0;
  let totalTax = 0;
  let totalDiscount = 0;

  quotationData.forEach((item) => {
    const qty = Number(item.qty || 0);
    const rate = Number(item.unitprice || 0);
    const discount = Number(item.discount || 0);
    const tax = Number(item.tax || 0);

    const base = qty * rate;
    const discountAmount = (base * discount) / 100;
    const taxable = base - discountAmount;

    totalDiscount += discountAmount;
    subTotal += taxable;
    totalTax += taxable * (tax / 100);
  });

  const cgst = totalTax / 2;
  const sgst = totalTax / 2;
  const totalBeforeRound = subTotal + totalTax;
  const roundedTotal = Math.round(totalBeforeRound);
  const roundOff = roundedTotal - totalBeforeRound;

  const summaryW = 82;
  const summaryX = pageWidth - margin - summaryW - 4;
  const wordsW = summaryX - margin - 6;

  // LEFT PLAIN ROWS: AMOUNT WORDS + CUSTOMER NOTES + TERMS
  const leftX = margin + 4;
  const leftY = y;
  const leftContentW = summaryX - leftX - 10;

  //Amount in words
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);

  doc.text("Amount in Words:", leftX, leftY + 5);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);

  const words = numberToWords?.(roundedTotal) || String(roundedTotal);

  doc
    .splitTextToSize(`Rupees ${words} Only`, leftContentW)
    .slice(0, 2)
    .forEach((line, i) => {
      doc.text(line, leftX, leftY + 8 + i * 3); //  changed from +9 to +6
    });

  // CUSTOMER NOTES
  const customerNotesText = stripHtml(
    quotation?.customer_notes ||
    quotation?.notes_to_customer ||
    ""
  );

  let noteY = leftY + 14;

  if (customerNotesText) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.setTextColor(...blue);
    doc.text("CUSTOMER NOTES", leftX, noteY);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.2);
    doc.setTextColor(30, 30, 30);

    noteY += 3;

    doc
      .splitTextToSize(String(customerNotesText), leftContentW)
      .slice(0, 4)
      .forEach((line) => {
        doc.text(line, leftX, noteY);
        noteY += 3.5;
      });
  }

  // TERMS & CONDITIONS

  const rawTerms =
    quotation?.tc_content ||
    selectedValue?.data ||
    "";

  {/*const rawTerms =
  quotation?.tc_content ||
  selectedValue?.data ||
  quteData?.tc_content ||
  ""; */}

  const termsText = rawTerms
    ? stripHtml(rawTerms).split("\n").filter(Boolean).slice(0, 6)
    : [
      "Prices are in INR.",
      "This quotation is valid for 30 days from the date issued.",
      "50% advance payment is required.",
      "Balance to be paid before delivery.",
      "Standard terms apply.",
    ];

  const termsY = noteY + 2;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...blue);
  doc.text("TERMS & CONDITIONS", leftX, termsY);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.2);
  doc.setTextColor(30, 30, 30);

  let ty = termsY + 3;

  termsText.forEach((term, index) => {
    const cleanTerm = String(term).replace(/^•\s*/, "").trim();

    const lines = doc
      .splitTextToSize(`${index + 1}. ${cleanTerm}`, leftContentW)
      .slice(0, 1);

    lines.forEach((line) => {
      doc.text(line, leftX, ty);
      ty += 3.5;
    });
  });

  const leftBottom = ty;
  const amountWordsY = y;


  const totalBaseAmount = subTotal + totalDiscount;

  const discountPercent =
    totalBaseAmount > 0
      ? ((totalDiscount / totalBaseAmount) * 100).toFixed(2)
      : "0.00";

  // RIGHT SUMMARY LIKE PHOTO
  const summaryRows = [
    ["Sub Total", subTotal + totalDiscount],
    ["Discount", `${money(totalDiscount)} / ${discountPercent}%`],
    ["Taxable Amount", subTotal],
    ["CGST (%)", cgst],
    ["SGST (%)", sgst],
    ["Round Off", roundOff],
  ];

  const totalSectionY = amountWordsY + 3;

  let sy = totalSectionY;

  summaryRows.forEach(([label, value]) => {
    doc.setDrawColor(...border);
    doc.setFillColor(255, 255, 255);
    doc.rect(summaryX, sy, summaryW, 5.5, "FD");

    doc.setTextColor(30, 30, 30);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(label, summaryX + 3, sy + 4.2);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text(
      typeof value === "string" ? value : money(value),
      summaryX + summaryW - 4,
      sy + 4,
      { align: "right" }
    );

    sy += 5.5;
  });

  // GRAND TOTAL BLUE ROW
  doc.setFillColor(...blue);
  doc.rect(summaryX, sy, summaryW, 7.5, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Grand Total", summaryX + 3, sy + 5);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.text(money(roundedTotal), summaryX + summaryW - 4, sy + 5, {
    align: "right",
  });

  const summaryBottom = sy + 8;

  y = Math.max(summaryBottom, leftBottom) + 2;
  addPageIfNeeded(36);

  // SINGLE COMBINED CARD
  const sideGap = 4;

  const combinedW = pageWidth - (margin * 2) - (sideGap * 2);
  const startX = margin + sideGap;
  const combinedH = 32;

  const sectionW = combinedW / 3;

  // Outer card
  doc.setDrawColor(...border);
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(startX, y, combinedW, combinedH, 1.5, 1.5, "FD");

  // Vertical dividers
  doc.line(startX + sectionW, y, startX + sectionW, y + combinedH);

  doc.line(startX + sectionW * 2, y, startX + sectionW * 2, y + combinedH);

  // ---------------- PAYMENT TERMS ----------------
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...blue);
  doc.text("PAYMENT TERMS", startX + 3, y + 6);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.2);
  doc.setTextColor(30, 30, 30);

  const selectedTerm =
    selectedPaymentTerm ||
    quotation?.payment_terms ||
    "50% Advance + 50% Before Delivery";

  const paymentOptions =
    paymentTermOptions.length > 0
      ? paymentTermOptions
      : [
        "100% Advance",
        "50% Advance + 50% Before Delivery",
        "Milestone Based",
        selectedTerm,
      ].filter((v, i, arr) => v && arr.indexOf(v) === i);

  let payY = y + 11;

  paymentOptions.slice(0, 5).forEach((term) => {
    const isSelected = String(term) === String(selectedTerm);

    doc.circle(startX + 4, payY - 1.2, 1.2, "S");

    if (isSelected) {
      doc.setFillColor(...blue);
      doc.circle(startX + 4, payY - 1.2, 0.7, "F");
    }

    doc.setFont("helvetica", isSelected ? "bold" : "normal");
    doc.setTextColor(30, 30, 30);

    const lines = doc.splitTextToSize(stripHtml(term), sectionW - 13).slice(0, 1);
    doc.text(lines[0], startX + 8, payY);

    payY += 4;
  });

  // ---------------- BANK DETAILS ----------------
  const bankX = startX + sectionW + 3;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...blue);
  doc.text("BANK DETAILS", bankX, y + 6);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.2);
  doc.setTextColor(30, 30, 30);

  let bankY = y + 11;

  [
    `Bank Name: ${bankAc?.bank_name || "-"}`,
    `Account Name: ${bankAc?.holder_name || "-"}`,
    `Account No: ${bankAc?.ac_no || "-"}`,
    `IFSC Code: ${bankAc?.ifsc_code || "-"}`,
  ].forEach((line) => {
    doc.text(line, bankX, bankY);
    bankY += 4;
  });

  // Note
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(5.5);
  doc.setTextColor(11, 93, 148);

  bankY += 2;

  doc.text(
    "* Please mention Quotation No. while making payment.",
    bankX,
    bankY,
    {
      maxWidth: 1000, // effectively disables wrapping
    }
  );

  bankY += 6;

  // ---------------- NOTES TO CUSTOMER ----------------
  const notesX = startX + sectionW * 2 + 3;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...blue);
  doc.text("NOTES TO CUSTOMER", notesX, y + 6);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.2);
  doc.setTextColor(30, 30, 30);

  doc.splitTextToSize(
    quotation?.notes_to_customer ||
    "",
    sectionW - 8
  )
    .slice(0, 5)
    .forEach((line, i) => {
      doc.text(line, notesX, y + 11 + i * 3.5);
    });

  y += combinedH + 2;




  // SINGLE COMBINED CARD FOR SCOPE / EXCLUSIONS / WARRANTY / DELIVERY



  const combinedCardW = pageWidth - (margin * 2) - (sideGap * 2);
  const scopeStartX = margin + sideGap;
  const columnW = combinedCardW / 4;

  // calculate dynamic height
  const scopeLines = doc.splitTextToSize(
    stripHtml(quotation?.scope || "-"),
    columnW - 8
  );

  const exclusionLines = doc.splitTextToSize(
    stripHtml(quotation?.exclusions || "-"),
    columnW - 8
  );

  const warrantyLines = doc.splitTextToSize(
    stripHtml(quotation?.support_warranty || "-"),
    columnW - 8
  );

  const deliveryLines = doc.splitTextToSize(
    stripHtml(quotation?.delivery_timeline || "30 - 45 Days"),
    columnW - 8
  );

  const maxLines = Math.max(
    scopeLines.length,
    exclusionLines.length,
    warrantyLines.length,
    deliveryLines.length
  );

  const combinedCardH = Math.max(30, 12 + maxLines * 3.5);

  // move entire section to next page BEFORE drawing
  if (y + combinedCardH + 10 > bottomLimit) {
    doc.addPage();

    // redraw page border
    doc.setDrawColor(...border);
    doc.rect(margin, 6, pageWidth - margin * 2, 285);

    y = 10;
  }

  // reset colors
  doc.setDrawColor(...border);
  doc.setFillColor(255, 255, 255);

  doc.roundedRect(
    scopeStartX,
    y,
    combinedCardW,
    combinedCardH,
    1.5,
    1.5,
    "FD"
  );
  // vertical dividers
  for (let i = 1; i < 4; i++) {
    doc.line(scopeStartX + columnW * i, y, scopeStartX + columnW * i, y + combinedCardH);
  }

  // helper
  const drawSection = (title, lines, x, icon) => {
    const titleY = y + 6;

    // Icon
    if (icon) {
      doc.addImage(
        icon,
        "PNG",
        x + 3,
        titleY - 2.5,
        3.5,
        3.5
      );
    }

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.5);
    doc.setTextColor(...blue);

    doc.text(
      title,
      x + 8,
      titleY
    );

    // Content
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.2);
    doc.setTextColor(30, 30, 30);

    lines.forEach((line, idx) => {
      doc.text(
        line,
        x + 3,
        y + 12 + idx * 3.5
      );
    });
  };

  // SCOPE
  drawSection(
    "SCOPE OF WORK",
    scopeLines,
    scopeStartX,
    scopeIcon
  );

  // EXCLUSIONS
  drawSection(
    "EXCLUSIONS",
    exclusionLines,
    scopeStartX + columnW,
    exclusionIcon
  );

  // WARRANTY
  drawSection(
    "SUPPORT & WARRANTY",
    warrantyLines,
    scopeStartX + columnW * 2,
    warrantyIcon
  );

  // DELIVERY
  drawSection(
    "DELIVERY TIMELINE",
    deliveryLines,
    scopeStartX + columnW * 3,
    deliveryIcon
  );

  y += combinedCardH + 4;

  //end of 4 card 
  addPageIfNeeded(22);

  const sigW = pageWidth - margin * 2;
  const colW = sigW / 3;

  const sigY = y + 2;
  const leftColCenterX = (margin + 4 + (margin + colW - 16)) / 2;
  const rightColCenterX = (margin + colW * 2 + 8 + pageWidth - margin - 8) / 2;

  // Titles
  doc.setTextColor(...blue);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(6.8);

  // Left title
  doc.text(
    "AUTHORIZATION",
    leftColCenterX,
    sigY + 1,
    { align: "center" }
  );

  // Right title
  doc.text(
    "CUSTOMER ACCEPTANCE",
    rightColCenterX,
    sigY + 1,
    { align: "center" }
  );

  // Thank You center
  // Thank You center
  doc.setFont("helvetica", "italic");
  doc.setFontSize(12);
  doc.text("Thank You!", margin + colW + colW / 2, sigY + 7, {
    align: "center",
  });

  // Signature image — fit strictly inside the gap between title and sig line
  if (dgSignBase64) {
    try {
      const gapTop = sigY + 3;      // just below "AUTHORIZATION" title
      const gapBottom = sigY + 33;  // just above the sig line (sigY + 34)
      const maxH = gapBottom - gapTop;   // available height (now ~30mm)
      const maxW = colW - 6;             // available width within left column (near full)
      let signW = maxW, signH = maxH;
      if (dgSignAspectRatio) {
        if (maxW / maxH > dgSignAspectRatio) {
          signH = maxH;
          signW = maxH * dgSignAspectRatio;
        } else {
          signW = maxW;
          signH = maxW / dgSignAspectRatio;
        }
      }

  const signX = leftColCenterX - signW / 2 + 3; // nudge right to visually center under title/labels
      const signY = gapTop + (maxH - signH) / 2; // vertically centered in the gap
      doc.addImage(dgSignBase64, "PNG", signX, signY, signW, signH);
    } catch (e) {
      console.error("quotation signature image failed:", e);
    }
  }

  // Lines
  doc.setDrawColor(80, 80, 80);
  doc.setLineWidth(0.25);

  doc.line(margin + 4, sigY + 30, margin + colW - 16, sigY + 30);

  doc.line(
    margin + colW * 2 + 8,
    sigY + 30,
    pageWidth - margin - 8,
    sigY + 30
  );

  // Labels
  doc.setTextColor(80, 80, 80);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(5.8);

  doc.text(
    "Authorized Signatory",
    leftColCenterX,
    sigY + 33.5,
    { align: "center" }
  );

  // Right label centered under right line
  doc.text(
    "Name & Signature",
    rightColCenterX,
    sigY + 33.5,
    { align: "center" }
  );

  // Tagline
  doc.setTextColor(...blue);
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(6.5);

  doc.text(
    "We look forward to working with you",
    margin + colW + colW / 2,
    sigY + 13,
    { align: "center" }
  );

  y = sigY + 37;
  // ── FOOTER IMAGE BAR ──────────────────────────
  if (footerBase64) {
    try {
      const footerImgW = pageWidth - margin * 2;
      const footerImgH = footerAspectRatio
        ? footerImgW / footerAspectRatio
        : 14;
      const footerImgY = pageHeight - footerImgH - 2;
      doc.addImage(
        footerBase64,
        "PNG",
        margin,
        footerImgY,
        footerImgW,
        footerImgH
      );
    } catch (e) {
      console.error("footer image failed:", e);
    }
  }

  return doc;
};

export default QuotationProfessionalTemplate;